export default __webpack_public_path__ + "static/media/Deed of Contract - Img - Final (2)_21.0643c581.jpg";